import { FILTERS_COMPONENT_CROPS } from '@features/regional-overview/domain/tests-id.constants';
import type { Filter, FilterOption } from '@features/regional-overview/regional-overview.models';
import { ALL_FILTER_VALUE, RegionalOverviewFilterType } from '@features/regional-overview/regional-overview.models';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SingleSelectFilter from '../../components/single-select-filter/single-select-filter.component';
import { FILTER_ALL_OPTION_KEY, FILTER_SECTION_TITLE_KEY } from '../../filter-labels.utils';
import { useFiltersStore } from '../../filters.store';

interface CropsSectionProps {
  filter: Filter;
  defaultExpanded?: boolean;
}

const CropsSection = ({ filter, defaultExpanded }: CropsSectionProps) => {
  const [t] = useTranslation();
  const options = useFiltersStore(state => state.options[RegionalOverviewFilterType.CROPS] ?? []);
  const raw = useFiltersStore(state => state.values[RegionalOverviewFilterType.CROPS]);
  const setValue = useFiltersStore(state => state.setValue);
  const value = typeof raw === 'string' ? raw : undefined;

  const merged = useMemo<FilterOption[]>(() => {
    if (!filter.includeAllOption) return options;
    const allKey = FILTER_ALL_OPTION_KEY[RegionalOverviewFilterType.CROPS];
    if (!allKey) return options;
    return [{ value: ALL_FILTER_VALUE, labelKey: allKey }, ...options];
  }, [options, filter.includeAllOption]);

  if (!options.length) return null;

  const titleKey = FILTER_SECTION_TITLE_KEY[RegionalOverviewFilterType.CROPS] ?? '';

  return (
    <SingleSelectFilter
      filter={RegionalOverviewFilterType.CROPS}
      title={t(titleKey)}
      options={merged}
      translatable={filter.translatable}
      value={value}
      onFilterChanged={(_t, v) => setValue(RegionalOverviewFilterType.CROPS, v)}
      defaultExpanded={defaultExpanded}
      dataTestID={FILTERS_COMPONENT_CROPS}
    />
  );
};

export default CropsSection;
